export const EDIT_MODAL = 'EDIT_MODAL';
export const EDIT_MODAL_SUCCESS = 'EDIT_MODAL_SUCCESS';
export const EDIT_MODAL_FAILURE = 'EDIT_MODAL_FAILURE';

export const ADD_FILES_MODAL = 'ADD_FILES_MODAL';
export const ADD_FILES_MODAL_SUCCESS = 'ADD_FILES_MODAL_SUCCESS';
export const ADD_FILES_MODAL_FAILURE = 'ADD_FILES_MODAL_FAILURE';